module.exports = __webpack_public_path__ + "static/media/manufacturer.b6e519ff.JPG";